module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_vm._m(0), _vm._v(" "), (_vm.step1) ? _c('div', [_c('div', {
    staticClass: "top-image step1"
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', [_vm._v("Indtast din nøgle")]), _vm._v(" "), _c('p', [_vm._v("For at kunne finde ud af hvilken forsyning, som du hører til, skal vi bruge en nøgle. Tryk på knappen nedenfor for at validere nøglen.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key),
      expression: "key"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Nøgle"
    },
    domProps: {
      "value": (_vm.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    staticStyle: {
      "max-height": "38px",
      "height": "38px"
    },
    on: {
      "click": _vm.validateKey
    }
  }, [(!_vm.downloading) ? _c('span', [_vm._v("Validér nøgle")]) : _vm._e(), _vm._v(" "), (_vm.downloading) ? _c('span', [_c('div', {
    staticClass: "loading-spinner"
  }), _vm._v("   Validerer...")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e(), _vm._v(" "), (_vm.step2) ? _c('div', [_c('div', {
    staticClass: "top-image step2"
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', [_vm._v("Vælg montør")]), _vm._v(" "), _c('p', [_vm._v("For at optimere din brugeroplevelse og sikre korrekt data, skal du fortælle os, hvem du er. Dette gøres i dropdown-feltet nedenfor.")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("Vælg en montør")]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n                        " + _vm._s(option.navn) + "\n                    ")])
  })], 2), _vm._v(" "), _c('a', {
    staticClass: "button",
    class: {
      disabled: _vm.empty
    },
    on: {
      "click": _vm.chooseUser
    }
  }, [_vm._v("Næste")]), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('p', {
    staticClass: "goback",
    on: {
      "click": _vm.gotoStep1
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")]), _vm._v(" \n                Tilbage\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.step3) ? _c('div', [_c('div', {
    staticClass: "top-image step3"
  }), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('h3', [_vm._v("Hent app'en og kom i gang")]), _vm._v(" "), _c('p', [_vm._v("Du er nu klar til at komme i gang. Tryk på knappen nedenfor for at hente nødvendige data ned på din enhed, så det fungerer uden internet og sikrer en bedre brugeroplevelse")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.getServerData
    }
  }, [_vm._v("Hent app")]), _vm._v(" "), _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('p', {
    staticClass: "goback",
    on: {
      "click": _vm.gotoStep2
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_back")]), _vm._v(" \n                Tilbage\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.showLoader) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "counter"
  }, [(_vm.errorMessage.length == 0) ? _c('div', [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "small-text-loading"
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.length > 0) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.errorMessage) + "\n                    "), _c('a', {
    staticClass: "button error-button",
    on: {
      "click": _vm.closeError
    }
  }, [_vm._v("Okay")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "steps"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.step1
    }
  }), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step2
    }
  }), _vm._v(" "), _c('li', {
    class: {
      active: _vm.step3
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-top"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/image/logo.png"),
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Installerer MålerTjek-app'en "), _c('span', {
    staticClass: "loading-overview"
  }, [_c('span', [_vm._v(".")]), _c('span', [_vm._v(".")]), _c('span', [_vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-240ecd74","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/init.vue
// module id = 1007
// module chunks = 1